<template>
  <v-card>
    <v-card-title primary-title class="py-2">
      <div class="subheading">
        {{ $t("view.commons.records") }}
      </div>
      <v-spacer />
      <v-btn icon @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-fade-transition>
      <v-card-text v-show="view.elem.datatable.visible" class="pt-0">
        <v-layout row wrap>
          <v-flex md12>
            <v-data-table
              ref="dataTable"
              item-key="username"
              class="usuario dataTable"
              sort-by="nombre"
              :sort-desc="false"
              :headers="view.elem.datatable.headers"
              :items="view.elem.datatable.data"
              :loading="view.elem.datatable.loading"
              :footer-props="view.elem.datatable.footerprops"
              :must-sort="true"
              :server-items-length="view.elem.datatable.total"
              :options.sync="options">
              <template #top>
                <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
              </template>
              <template #item.fotoMiniatura="{ item }">
                <v-avatar size="40px">
                  <img :src="item.fotoMiniatura ? item.fotoMiniatura : '/static/img/user_thumbnail.jpg'" :alt="item.username" />
                </v-avatar>
              </template>
              <template #item.nombre="{ item }">
                {{ item.nombre }} ({{ item.username }})
              </template>
              <template #item.accion="{ item }">
                <buttonCustom
                  :ref="`dataTableBtnPerfiles_${item.username}`"
                  :paramtype="'Object'"
                  :paramobj="item"
                  :showcustom="$userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                  action="perfiles"
                  icon="fas fa-user-plus"
                  :title="$t('view.seguridad.usuario.button.perfiles')"
                  @perfiles="perfiles" />

                <buttons
                  :ref="`dataTableBtn_${item.username}`"
                  :key="refreshkey"
                  :clavestr="item.username"
                  :descripcion="item.nombre"
                  :showdisable="item.enabled && $userPermission.hasPermission('ROLE_MODIFICAR_SEGURIDAD')"
                  @edit="edit"
                  @disable="disable"
                  @audit="audit" />
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-fade-transition>
  </v-card>
</template>

<script>
import UsuarioAPI from "@/services/seguridad/usuario"; /** *******************************/
import Buttons from "@/components/datatable/Buttons"; /** *******************************/
import ButtonCustom from "@/components/datatable/ButtonCustom"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";
import { disableSwal } from "@/constants/sweet-alerts";
import { handleResponse } from "@/helpers/http-response-handler";

export default {
  name: "DataTable"
  , components: { Buttons, ButtonCustom }
  , data() {
    return {
      options: {}
      , filtros: {}
      , search: ""
      , refreshkey: 0
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: "#", align: "center", sortable: false, class: "fotoMiniatura", cellClass: "fotoMiniatura", value: "fotoMiniatura" }
              , { text: this.$t("view.seguridad.usuario.form.nombre.th"), align: "left", sortable: true, class: "nombre", cellClass: "nombre", value: "nombre" }
              , { text: this.$t("view.commons.accion"), align: "center", sortable: false, class: "accion", cellClass: "accion", value: "accion" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await UsuarioAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);
      this.refreshkey += 1;

      this.view.elem.datatable.loading = false;
    }
    , async perfiles(item) {
      const { username, nombre } = item;
      this.$emit("showPerfiles", username, nombre);
    }
    , async edit(username) {
      this.$emit("editRow", username);
    }
    , async disable(username) {
      if ((await this.$swal(disableSwal)).value) {
        if (handleResponse(await UsuarioAPI.disable({ username }))) {
          this.load();
          if (username == this.$parent.usuario.username) this.$emit("editRow", username);
        }
      }
    }
    , async audit(username, descripcion) {
      this.$emit("auditRow", username, descripcion);
    }
    , refreshData() {
      this.load();
    }
  }
};
</script>

<style>
.usuario .fotoMiniatura {
  width: 100px !important;
  min-width: 100px !important;
}

.usuario .accion {
  width: 180px !important;
  min-width: 180px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/seguridad/usuario/DataTable.vue